// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d85d921b","453":"59b8a61b"}[chunkId] + ".chunk.js";
};